// ----------------------------------------------------------------------------
// Section: Card Flip
// ----------------------------------------------------------------------------

import { cart } from 'scripts/helpers/iamota-shopify-ajax';
import translate from 'scripts/helpers/iamota-translate';
import './_card-flip.scss';

// -------------------------------------
// Variables
// -------------------------------------
var SECTION_SELECTOR = '[data-card-flip]';
var CARD_SELECTOR = '[data-card-flip-card]';
var CLOSE_SELECTOR = '[data-card-flip-close]';
var DETAILS_SELECTOR = '.card-flip-card__details-label';
var ATC_SELECTOR = '[data-card-flip-add-to-cart]';
var ATC_ERROR_SELECTOR = '[data-card-flip-atc-error]';
var REVEALED_CLASS = 'is-revealed';
var INITIALIZED_CLASS = 'is-initialized';
var LOADING_CLASS = 'is-loading';
var ITEM_ADDED_DURATION = 3000;
var TABLET_BREAKPOINT = '(min-width: 768px)';

// -------------------------------------
// Reveal / hide
// -------------------------------------
function revealCard(card) {
  card.classList.add(REVEALED_CLASS);
  var backFace = card.querySelector('.card-flip-card__face--back');
  if (backFace) {
    backFace.setAttribute('aria-hidden', 'false');
  }
}
function hideCard(card) {
  card.classList.remove(REVEALED_CLASS);
  var backFace = card.querySelector('.card-flip-card__face--back');
  if (backFace) {
    backFace.setAttribute('aria-hidden', 'true');
  }
}

// -------------------------------------
// Add to cart
// -------------------------------------
function initAddToCart(card) {
  card.querySelectorAll(ATC_SELECTOR).forEach(button => {
    button.addEventListener('click', event => {
      event.stopPropagation();
      if (button.disabled || button.classList.contains(LOADING_CLASS)) {
        return;
      }
      var variantId = button.dataset.variantId;
      var needsVariantSelection = button.dataset.needsVariantSelection === 'true';
      var productUrl = button.dataset.productUrl;
      if (needsVariantSelection && productUrl) {
        window.location.href = productUrl;
        return;
      }
      if (!variantId) {
        return;
      }
      var labelEl = button.querySelector('[data-card-flip-add-label]');
      var errorEl = card.querySelector(ATC_ERROR_SELECTOR);
      var originalLabel = labelEl ? labelEl.textContent : '';
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      button.classList.add(LOADING_CLASS);
      button.disabled = true;
      if (labelEl) {
        labelEl.textContent = translate('Adding to cart...', 'addToCart.adding_to_cart');
      }
      cart.addItem({
        id: variantId,
        quantity: 1
      }).then(() => {
        if (labelEl) {
          labelEl.textContent = translate('Item added to cart', 'addToCart.item_added');
        }
        window.setTimeout(() => {
          if (labelEl) {
            labelEl.textContent = originalLabel;
          }
          button.disabled = false;
          button.classList.remove(LOADING_CLASS);
        }, ITEM_ADDED_DURATION);
      }).catch(error => {
        if (labelEl) {
          labelEl.textContent = originalLabel;
        }
        button.disabled = false;
        button.classList.remove(LOADING_CLASS);
        if (errorEl) {
          errorEl.textContent = (error === null || error === void 0 ? void 0 : error.message) || translate('Unable to add', 'addToCart.error');
          errorEl.hidden = false;
        }
      });
    });
  });
}

// -------------------------------------
// Init
// -------------------------------------
function initSection(section) {
  if (!section || section.classList.contains(INITIALIZED_CLASS)) {
    return;
  }
  section.classList.add(INITIALIZED_CLASS);
  var cards = Array.from(section.querySelectorAll(CARD_SELECTOR));
  var isDesktop = () => window.matchMedia(TABLET_BREAKPOINT).matches;
  cards.forEach(card => {
    var frontFace = card.querySelector('.card-flip-card__face--front');
    var detailsLabel = card.querySelector(DETAILS_SELECTOR);
    var hasBack = !!card.querySelector('.card-flip-card__face--back');
    if (!hasBack) {
      return;
    }
    card.addEventListener('mouseenter', () => {
      if (isDesktop()) {
        revealCard(card);
      }
    });
    card.addEventListener('mouseleave', () => {
      if (isDesktop()) {
        hideCard(card);
      }
    });
    if (detailsLabel) {
      detailsLabel.addEventListener('click', event => {
        event.stopPropagation();
        revealCard(card);
      });
    }
    if (frontFace) {
      var _frontFace$querySelec;
      frontFace.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          revealCard(card);
        }
      });
      frontFace.setAttribute('tabindex', '0');
      frontFace.setAttribute('role', 'button');
      frontFace.setAttribute('aria-label', ((_frontFace$querySelec = frontFace.querySelector('.card-flip-card__heading')) === null || _frontFace$querySelec === void 0 || (_frontFace$querySelec = _frontFace$querySelec.textContent) === null || _frontFace$querySelec === void 0 ? void 0 : _frontFace$querySelec.trim()) || '');
    }
    var closeBtn = card.querySelector(CLOSE_SELECTOR);
    if (closeBtn) {
      closeBtn.addEventListener('click', event => {
        event.stopPropagation();
        hideCard(card);
      });
    }
    initAddToCart(card);
  });
}
function initCardFlips() {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  if (container.matches && container.matches(SECTION_SELECTOR)) {
    initSection(container);
  }
  container.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
}

// -------------------------------------
// Hooks
// -------------------------------------
initCardFlips();
document.addEventListener('shopify:section:load', event => {
  initCardFlips(event.target);
});